// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__CteoA","title":"AfterFrontImage_title__2CajA"};